import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/google-financial-statements')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/google-financial-statements']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
